export const CREATE_STACK_IMAGE = "CREATE_STACK_IMAGE";
